import { render } from "./DriverFeedbackForm.vue?vue&type=template&id=33af5e8c&scoped=true&ts=true"
import script from "./DriverFeedbackForm.vue?vue&type=script&lang=ts"
export * from "./DriverFeedbackForm.vue?vue&type=script&lang=ts"

import "./DriverFeedbackForm.vue?vue&type=style&index=0&id=33af5e8c&scoped=true&lang=scss"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33af5e8c"]])

export default __exports__